// @mui
import { GlobalStyles as MUIGlobalStyles } from '@mui/material';
import '../css/App.css'

// ----------------------------------------------------------------------

export default function GlobalStyles() {
  const inputGlobalStyles = (
    <MUIGlobalStyles
      styles={{
        '*': {
          boxSizing: 'border-box',
          margin:0,
          padding:0,
        },
        html: {
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          width: '100%',
          height: '100%',
          fontFamily:'Pretendard-Regular',
          lineHeight:'1.3 !important',
        },
        '#root': {
          width: '100%',
          height: '100%',
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },

        li: {
          listStyle:'none',
        },
        h1: {
          fontSize:'2.6rem',

        },
        h2: {
          fontSize:'2.2rem',
          fontWeight:600,
        },
        h3: {
          fontSize:'1.8rem',
          fontWeight:600,

        },
        h4: {
          fontSize:'1.4rem',
          fontWeight:500,

        },
        button: {
            border:'none',
            fontSize:'1rem',
        }
      }}
    />
  );

  return inputGlobalStyles;
}
